/**
 * Central place for every banner icon.  Add once – autocomplete everywhere.
 * Use dynamic import so *unused* icons are tree-shaken away.
 */
import { ArrowUpRightIcon, CircleCheckIcon, CircleHelpIcon, CircleIcon } from "lucide-react";
// import dynamic from "next/dynamic";
import { type ReactNode } from "react";

export const iconMap: Record<string, ReactNode> = {
  ArrowUpRightIcon: <ArrowUpRightIcon />,
  CircleCheckIcon : <CircleCheckIcon />,
  CircleHelpIcon  : <CircleHelpIcon />,
  CircleIcon      : <CircleIcon />,
  DiscountIcon    : <CircleIcon />,
  // DiscountIcon    : dynamic(() => import("./DiscountSvg").then(m => m.DiscountIcon), {
  //   ssr: false,                      // rendered only on client
  //   loading: () => null,
  // }),
};
 
export type IconName = keyof typeof iconMap;